import createErrorInterceptor from './ErrorInterceptor';
import FetchService, { Interceptor } from './FetchService';
import Shell from './Shell';

export { createErrorInterceptor, FetchService, Interceptor, Shell };



// WEBPACK FOOTER //
// ./src/core/index.ts